<template>
  <section class="">
    <div v-if="appLoading" class="h-[500px] flex justify-center items-center">
      <app-loader></app-loader>
    </div>
    <div v-else class="">
      <app-custom-table
        title="All Project Funds"
        :headers="tableHeaders"
        :items="allPmLocals"
        rowStyles="cursor-pointer"
        @item-click="handleItemClick"
        show-pagination
        :total-items="totalPages"
        :current-page="currentPage"
        :load-more-pagination-data="getAllPmLocals"
      />
    </div>
  </section>
</template>
<script>
import { defineComponent } from "vue";

import { mapState } from "vuex";
import countries from "@/services/country_api";

export default defineComponent({
  name: "PmLocalsList",

  data() {
    return {
      localCurrentPage: 1,
    };
  },
  watch: {
    currentPage(val) {
      this.localCurrentPage = val;
    },
  },
  computed: {
    allPmLocals() {
      const modifiedData = this.$store.getters["pmLocalModules/allPmLocals"];
      return modifiedData?.map((data) => {
        return {
          ...data,
          icon_personnel_on_site: data.icon_personnel_on_site?.map((person) => {
            return `${person.first_name}  ${person.last_name}`;
          }),
          period:
            data.project__project_end_date === null
              ? data.project__project_start_date?.formattedDate()
              : `${data.project__project_start_date?.formattedDate()} - ${data.project__project_end_date?.formattedDate()}`,
        };
      });
    },
    tableHeaders() {
      return this.$store.getters["pmLocalModules/tableHeaders"];
    },
    canEdit() {
      const modifiedData = this.$store.getters["auth/canEdit"];
      const findModules = modifiedData?.filter(
        (module) => module.module_name === "PM-Local"
      );
      return findModules?.length !== 0;
    },
    currentPage() {
      return this.$store.getters["pmLocalModules/isCurrentPage"];
    },
    totalPages() {
      return this.$store.getters["pmLocalModules/isTotalPages"];
    },
    countryOptions() {
      return countries?.map((country) => country.name);
    },
    appLoading() {
      return this.$store.getters["pmLocalModules/appLoading"];
    },
    appLocaleLang() {
      return this.translation.locale;
    },
    ...mapState(["translation"]),
  },
  methods: {
   
  
    getAllPmLocals(page = this.localCurrentPage) {
      const payload = {
        load_page: false,
        page_number: page,
      };
      this.$store.dispatch("pmLocalModules/getAllPmlocals", payload);
    },
    handleItemClick(data) {
      const projectTitle = [data?.project__cost_centre__cost_center_number, data?.project__project_title]?.filter(Boolean)?.join(" ")
      this.$store.commit("hrResources/SET_SHOW_EDIT_BUTTON_TO_STATE", true);
      this.$store.commit("pmLocalModules/SET_PM_LOCAL_ID_STATE", data?.id);
      this.$store.commit("pmLocalModules/SET_PM_LOCAL_TITLE_STATE", projectTitle);
      setTimeout(() => {
        this.$router.push({ name: "editPmLocal" });
      });
    },
  },
  created() {
    this.$store.commit("commonResources/SET_CURRENT_TAB_TO_STATE", 0);
    this.$store.commit("projectOverview/SET_ADD_EXPENSE_TO_STATE", true);
    this.$store.commit("chequeModules/SET_ADD_CHEQUE_TO_STATE", false);
    this.$store.commit("pmLocalModules/SET_SHOW_REQUEST_NEW_FUND", false);
  },
  mounted() {
    this.getAllPmLocals();
  }

});
</script>
